import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useActiveLang } from "@/hooks/use-active-lang";
import { BUEN_FIN_COPY } from "@/lib/buen-fin";
import qr from "@/assets/buen-fin-2026-qr-oficial.png.asset.json";

const VERIFY_URL = "https://www.elbuenfin.org/consultaQR/e1e86e2e-8d48-4ed3-a97c-cf2a2f56efce";

/** Original uploaded pixels; verified against the official participant page. */
export function BuenFinQr({ compact = false }: { compact?: boolean }) {
  const [open, setOpen] = useState(false);
  const lang = useActiveLang(); const L = BUEN_FIN_COPY[lang];
  return <div className={compact ? "buen-fin-qr-compact" : "buen-fin-qr-full"}>
    <Button variant="ghost" className="buen-fin-qr-button bg-ivory text-night hover:bg-ivory" aria-label={L.participant} onClick={() => setOpen(true)}>
      <img src={qr.url} alt={L.participant} width={480} height={480} className="block h-full w-full object-contain" />
    </Button>
    {compact && <div className="buen-fin-qr-hover bg-ivory text-night" aria-hidden><img src={qr.url} alt="" width={480} height={480} className="h-auto w-full" /><p>{L.participant}</p></div>}
    {!compact && <p className="mt-2 text-center text-xs">{L.participant}</p>}
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="max-w-md"><DialogHeader><DialogTitle>{L.participant} · Mostrando México</DialogTitle></DialogHeader><img src={qr.url} alt={L.participant} width={480} height={480} className="h-auto w-full bg-ivory" /><Button asChild variant="outline"><a href={VERIFY_URL} target="_blank" rel="noopener noreferrer">www.elbuenfin.org ↗</a></Button></DialogContent></Dialog>
  </div>;
}